import {AlertLogicProps} from '@/componentLibrary/blocks/Modals/Alert/types';
import {isDefined} from '@/utils/typeGuards/isDefined';
import {RefObject, useEffect, useRef} from 'react';

export const useAlertLogic = ({close}: AlertLogicProps) => {
    const ref = useRef<HTMLDivElement | null>(null);

    useCloseOnEscape(ref, close);

    return {ref};
};

const useCloseOnEscape = (ref: RefObject<HTMLDivElement | null>, close?: () => void) => {
    useEffect(() => {
        if (!isDefined(close)) {
            return;
        }

        const handleKeyPress = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                close?.();
            }

            event.stopImmediatePropagation();
        };

        ref.current?.addEventListener('keyup', handleKeyPress);

        return () => ref.current?.removeEventListener('keyup', handleKeyPress);
    }, [ref, close]);
};
